/* eslint-disable react/prefer-stateless-function */
/* eslint-disable jsx-a11y/alt-text */
import React from "react";

import styled from "styled-components";

const AboutUsContainer = styled.div`
  height: 90vh;
  padding-left: 100px;
  padding-right: 100px;
   padding-top: 100px;
  background-color: #f9f9f9;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  @media (max-width: 768px) {
    padding-left: 75px;
    padding-right: 75px;
    padding-top: 0px;
    height: auto;
  }
`;

const Title = styled.h2`
  font-size: 2rem;
  margin-bottom: 10px;
  font-weight: bold;
  color: #041c40;
  text-align: center;
  font: normal normal bold 60px / 53px;
`;

const Divider = styled.div`
  width: 100px;
  height: 3px;
  background-color: #f7bc0c;
  margin: 0 auto 30px;
`;

export default function Missionyvision(props) {
  return (
    <AboutUsContainer id="vision">
      <div className="row">
        <div
          className="col-lg-6 col-md-6 col-sm-12 col-12 p-0 pt-2 pb-0 fs-5 text-start"
          style={{ alignSelf: "center", color: "#707070" }}
        >
          <Title>Mission</Title>
          <Divider />
          To provide our customers with the best quality in our carpentry
          services by satisfying the need of innovation, comfort and security in
          their homes.
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12 col-12 pt-5 pt-0 pb-0 ps-4"></div>
        <div className="col-lg-6 col-md-6 col-sm-12 col-12 pt-5 pt-0 pb-0">
          {" "}
          {/* <img src="img/banners/carrousel.jpg" style={{"max-height":"400px","max-width":"800px"}}/>*/}
        </div>
        <div
          className="col-lg-6 col-md-6 col-sm-12 col-12 pt-0 pb-4 mb-4 fs-5 text-start"
          style={{ alignSelf: "center", color: "#707070", "font-weight": 100 }}
        >
          <Title>Visión</Title>
          <Divider />
          Our vision is to be a leading company within our environment and to
          offer the most innovative products of the highest quality, making us
          an important option in the market for quality, efficiency,
          profitability and safety
        </div>
      </div>
    </AboutUsContainer>
  );
}
